export const cdnConfig = {
  default: 'https://s3.eu-central-1.amazonaws.com/cdn.podosmart.tech'
};
